import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes: 0,
  message: '',
  data: []
};

export const contactUsSlice = createSlice({
    name: 'contactUs',
    initialState,
    reducers: {
        getDashboardData: (state) => {
          state.loading = true;
          state.error = null;
        },
        getContactUs: (state) => {
          state.loading = true;
          state.error = null;
        },
        removeContactUs: (state) => {
          state.loading = true;
          state.error = null;
        },
        updateContactUs: (state) => {
          state.loading = true;
          state.error = null;
        },
        successContactUs: (state, action) => {
          state.loading = false;
          state.error = null;
          state.data = action.payload;
        },
        failedContactUs: (state, action) => {
          state.loading = false;
          state.error =
            action.payload?.response?.data?.message ||
            action.payload?.data?.message ||
            action.payload?.message ||
            action.payload ||
            'Something went wrong';
        },
    },
})

// Action creators are generated for each case reducer function
export const { getContactUs, removeContactUs, updateContactUs, successContactUs, failedContactUs, getDashboardData } = contactUsSlice.actions

export default contactUsSlice.reducer
